// Import
import { FNAlerts } from './src/alerts';
import { Fancybox } from './src/fancybox';
import { Carousel } from './src/carousel';
import Menu from './src/menu';
import MenuPlaceholder from './src/menuPlaceholder';

// Export
export {
  FNAlerts,
  Fancybox,
  Carousel,
  Menu,
  MenuPlaceholder
};



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/index.js